import FArray from '@/plugins/form/FArray';
import Item from './Item';
import FDictionaryService from '@/modules/Dictionary/Service/Select';

export default class extends FArray {
  serviceAdd = new FDictionaryService();

  constructor(props) {
    super(props);
    this.tour = props.parent;
    this.tariffs = props.tariffs;
  }

  get data() {
    return this.items.map(i => i.data);
  }

  set data(value) {
    this.__value = [];
    value.forEach((i) => {
      try {
        const item = Item({
          value: i.ServiceClass.Id,
          label: i.ServiceClass.Name,
          isCity: i.ServiceClass.IsCity,
          isID1: i.ServiceClass.IsID1,
          isID2: i.ServiceClass.IsID2,
          servicePrices: [],
        });
        this.push(item);
        item.setData(i)
          .init();
      } catch (e) {
        console.log(e);
      }
    });
  }

  deleteServicePrice(item) {
    this.__value.forEach((service) => {
      service.servicePrices = service.servicePrices.filter(x => x.TourTariffId !== item.tariffId);
    })
  }

  add(service) {
    console.log('service add');
    const item = Item(service);
    this.push(item);
    return item.init()
      .then(() => item);
  }

  handlerAdd(service) {
    const item = Item(service);
    this.push(item);
    item.init();
    return item;
  }
}
